<!-- 图片链接列表：模块头+图片+标题+链接 -->
<template>
<div class="content-block">
  <div class="info-list-title">
    <span>{{title}}</span>
    <label>{{label}}</label>
    <a href="#" v-if="showMore">更多</a>
  </div>
  <div class="info-list-content">
    <div class="list-container">
      <div class="list-container-cell" v-for="(n,index) in (infoList.length>countN?countN:infoList.length)" :style="{'width': celWidth}">
        <router-link :to="{path: infoList[n-1].link}">
          <div class="cell-base-info"  @mouseover="iconIndex[n-1].icon = 1" @mouseleave="iconIndex[n-1].icon  = 0">
            <div v-bind:class="['base-info-title',infoList[n-1].class]">{{infoList[n-1].title}}</div>
            <div v-bind:class="['base-info-label',infoList[n-1].class]">{{infoList[n-1].label}}</div>
            <div v-bind:class="['base-info-image',infoList[n-1].class]" v-bind:style="{backgroundImage:'url('+require('./../../assets/'+infoList[n-1].icon+iconIndex[n-1].icon +'.png')+')'}"></div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'ImgLink01',
  props: {
    title: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    showMore: {
      type: Boolean,
      default: true
    },
    col: {
      type: String,
      default: '3'
    },
    count:{
      type:String,
      default:'3'
    }
  },
  data() {
    let that=this;
    return {
      iconIndex:[{icon:0},{icon:0},{icon:0}],
      celWidth: "calc(100%/" + this.col + ")",
      infoList: [],
      countN:Number(this.count),
    }
  },
  created:function(){

    this.infoList=this.Global.mainServiceList;


  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
a {
  color: #42b983;
  text-decoration: none;
}

.list-container {
  display: flex;
  flex-wrap: wrap;
}

.list-container-cell {
  box-sizing: border-box;
  height: 160px;
  background: #eee;
  border: 0px solid red;
}

.list-container-cell a {
  display: block;
  box-sizing: border-box;
  padding:5px;
  margin:40px 40px 40px 40px;
  background-color: #eee;
  border:1px solid #eee;

}

.list-container-cell a:hover{
  //border:1px solid #eee;
  //box-shadow:0px 0px 1px 1px #eee;
  //background:#fff;
}

.list-container-cell a:hover > div > div{
  //border:1px solid #eee;
  //box-shadow:0px 0px 1px 1px #eee;
  //background:#fff;
  color:var(--color6);
}

.list-container-cell .cell-base-info{
  position:relative;
  height:70px;
  color:#000;
  padding-right:0px;
}

.cell-base-info .base-info-title{
  float:left;
  height:40px;
  margin-left:80px;
  font-size:18px;
  font-weight:600;
  line-height:40px;
}

.cell-base-info .base-info-label{
  float:left;
  height:30px;
  margin-left:80px;
  font-size:12px;
  line-height:20px;
}

.cell-base-info .base-info-image{
  position:absolute;
  top:0px;
  left:0px;
  height:70px;
  width:70px;
  color:#000;
  border-radius:35px;
  //background-color:#fff;
  padding-right:70px;
  background-size: 70px auto;
  background-repeat: no-repeat;
  background-position: center center;
}

.style-1{
  //color:var(--color6);
  color:#477931;
}

.style-2{
  color:#477931;
}

.style-3{
  color:#477931;
}
</style>



// WEBPACK FOOTER //
// src/components/block/ImgLink01.vue